import { UserOutlined } from '@ant-design/icons'
import { useApolloClient, useMutation, useQuery } from '@apollo/client'
import { Badge, Col, Drawer, Dropdown, Empty, Menu, Row, Spin } from 'antd'
import Avatar from 'antd/lib/avatar/avatar'
import { motion } from 'framer-motion'
import React from 'react'
import { AiFillCaretDown, AiFillHome as HomeIcon } from 'react-icons/ai'
import { BiBell, BiChat, BiLogOutCircle } from 'react-icons/bi'
import { BsFillHouseFill as AccomodationIcon } from 'react-icons/bs'
// import { ApolloClient } from "@apollo-client";
import { CgProfile as ProfileIcon } from 'react-icons/cg'
import {
  FaPuzzlePiece as GameIcon,
  FaToolbox as ServicesIcon,
} from 'react-icons/fa'
import { HiMenuAlt1 } from 'react-icons/hi'
import { IoMdSchool } from 'react-icons/io'
import {
  IoLocationSharp as LocateIcon,
  IoSettingsSharp as SettingsIcon,
} from 'react-icons/io5'
import { MdVoiceChat } from 'react-icons/md'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import {
  ACCEPT_REQUEST,
  DENY_REQUEST,
  GET_AUTH_USER,
  GET_REQUESTLIST,
  UPDATE_CURRENT_COUNTRY,
} from '../app/apollo/index'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import pusherClient from '../app/pusher'
import Room from '../app/Room'
import DarkLogo from '../assets/atlasLogoDark.png'
import LightLogo from '../assets/atlasLogoLight.png'
import { UserList } from '../Components/Locate/Style'
import { device } from '../globalAssets/breakpoints'
import { desktop, mobile } from '../globalAssets/fontsize'
import DashboardRoute from '../globalComponents/DashboardRoute'
import withAuthentication from '../HOC/withAuth'
import { NotificationAlert } from '../utils/NotificationAlert'
import { LoadingScreen } from './LoadingScreen'
import { mode, toggleDark, toggleLight } from './slice/modeSlice'
import { updateUserInfo } from './slice/userDataSlice'

interface LayoutType {
  title: string
}

const route = [
  {
    id: 1,
    title: 'Home',
    icon: <HomeIcon />,
    route: '/home',
  },
  // {
  //   id: 2,
  //   title: "Post Accomodation",
  //   icon: <AdvertIcon />,
  //   route: "/home/post",
  // },
  {
    id: 3,
    title: 'Meet People',
    icon: <LocateIcon />,
    route: '/home/locate',
  },
  {
    id: 7,
    title: 'Education',
    icon: <IoMdSchool />,
    route: '/home/education',
  },
  {
    id: 8,
    title: 'Accomodation',
    icon: <AccomodationIcon />,
    route: '/home/accomodation',
  },
  {
    id: 9,
    title: 'Services',
    icon: <ServicesIcon />,
    route: '/home/services',
  },
  {
    id: 4,
    title: 'Community',
    icon: <MdVoiceChat />,
    route: '/home/community',
  },

  {
    id: 5,
    title: 'Win a Game',
    icon: <GameIcon />,
    route: '/home/game',
  },
  {
    id: 10,
    title: 'Profile',
    icon: <ProfileIcon />,
    route: '/home/profile',
  },
  {
    id: 6,
    title: 'Settings',
    icon: <SettingsIcon />,
    route: '/home/settings',
  },
]
const AppLayout: React.FC<LayoutType> = (props) => {
  const [drawerVisible, setDrawerVisible] = React.useState<boolean>(false)
  const dispatcher = useAppDispatch()
  const roomState = useAppSelector((state) => state.room)
  const userState = useAppSelector((state) => state?.userInfoReducer?.content)
  const history = useHistory()
  const lightmode = useAppSelector(mode)
  const client = useApolloClient()
  const location = useLocation()
  const { data, loading: queryLoading } = useQuery(GET_AUTH_USER)
  const { data: listData, loading: listLoading } = useQuery(GET_REQUESTLIST, {
    variables: {
      itemsPerPage: 60,
    },
  })
  const [updateCurrentCountry] = useMutation(UPDATE_CURRENT_COUNTRY)
  const [acceptChatRequest] = useMutation(ACCEPT_REQUEST)
  const [denyChatRequest] = useMutation(DENY_REQUEST)
  React.useEffect(() => {
    dispatcher(updateUserInfo(data?.getAuthUser))
  }, [data?.getAuthUser])

  React.useEffect(() => {
    if (queryLoading || !userState?.id) return
    pusherClient()
  }, [queryLoading, userState?.id])

  React.useEffect(() => {
    async function onGeolocateSuccess(coordinates: any) {
      const { latitude, longitude } = coordinates.coords
      // console.log("Found coordinates: ", latitude, longitude);
      try {
        const response = await updateCurrentCountry({
          variables: {
            location: { lat: `${latitude}`, lng: `${longitude}` },
          },
        })
        // console.log("update current", response);
      } catch (e) {
        console.log(e)
      }
    }

    function onGeolocateError(error: any) {
      // console.warn(error.code, error.message);

      if (error.code === 1) {
        alert('Kindly allow access to location and try again')
      } else if (error.code === 2) {
        alert("Location is curretly unavailable, you can't proceed")
        // localStorage.removeItem("token")
      } else if (error.code === 3) {
        alert('Timeout')
      }
    }
    if (window.navigator && window.navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        onGeolocateSuccess,
        onGeolocateError,
      )
    }
  }, [])
  const acceptRequest = async (id: number) => {
    try {
      const response = await acceptChatRequest({
        refetchQueries: [{ query: GET_REQUESTLIST }],
        variables: {
          request_id: id,
        },
      })
      if (response) {
        if (response?.data?.acceptChatRequest?.success) {
          NotificationAlert(
            'success',
            'Successful',
            response?.data?.acceptChatRequest?.msg,
          )
        } else {
          NotificationAlert(
            'Error',
            'Error Occured',
            response?.data?.acceptChatRequest?.msg,
          )
        }
      }
    } catch (e) {
      NotificationAlert('error', 'Error occured', 'Try again')
    }
  }
  const denyRequest = async (id: number) => {
    try {
      const response = await denyChatRequest({
        refetchQueries: [{ query: GET_REQUESTLIST }],
        variables: {
          request_id: id,
        },
      })
      if (response) {
        if (response?.data?.denyChatRequest?.success) {
          NotificationAlert(
            'success',
            'Successful',
            response?.data?.denyChatRequest?.msg,
          )
        } else {
          NotificationAlert(
            'Error',
            'Error Occured',
            response?.data?.denyChatRequest?.msg,
          )
        }
      }
    } catch (e) {
      NotificationAlert('error', 'Error occured', 'Try again')
    }
  }
  // console.log("list data data", listData);
  const userList = listData?.getMyChatRequest?.chatRequest?.map(
    (person: any) => (
      <UserList>
        {person?.user?.photolink ? (
          <img src={person?.user?.photolink} alt={person?.user?.firstname} />
        ) : (
          <Avatar size={{ xs: 50, xl: 60 }} icon={<UserOutlined />} />
        )}
        <div>
          <h1>
            {person?.user?.firstname} {person?.user?.lastname}
          </h1>
          <h2>{person?.message}</h2>
          <h2>
            currently in {person?.user?.currentCountry?.country},
            {person?.user?.currentCountry?.city}
          </h2>
          {console.log('person response', person)}
        </div>
        {person?.createdByMe ? (
          <h5 style={{ color: 'red' }}> request sent</h5>
        ) : (
          <>
            <button
              style={{
                background: 'green',
                color: 'black',
                marginRight: '5px',
              }}
              onClick={() => acceptRequest(person?.id)}
            >
              accept
            </button>
            <button
              style={{ background: 'red', color: 'white' }}
              onClick={() => denyRequest(person?.id)}
            >
              deny
            </button>
          </>
        )}
      </UserList>
    ),
  )
  const notificationMenu = (
    <StyledMenu>
      {listLoading && (
        <MenuItem>
          <Spin />
        </MenuItem>
      )}
      {listData?.getMyChatRequest?.chatRequest?.length === 0 && (
        // <MenuItem>
        <MenuItem>
          <Empty
            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
            description={<span>No notification</span>}
          />
        </MenuItem>
        // </MenuItem>
      )}
      {listData?.getMyChatRequest?.chatRequest?.length > 0 && userList}
    </StyledMenu>
  )

  const menu = (
    <StyledMenu style={{ width: '100px' }}>
      <MenuItem onClick={() => history.push(`/home/profile`)}>
        <span style={{ marginLeft: '5px' }}>Profile</span>
      </MenuItem>
      <MenuItem onClick={() => handleLogOut()}>
        <span style={{ marginLeft: '5px', color: 'red' }}>LogOut</span>
      </MenuItem>
    </StyledMenu>
  )
  const handleLogOut = () => {
    history.replace('/login')
    client.clearStore()
    localStorage.removeItem('token')
  }
  const onChange = (): void => {
    lightmode === 'dark' ? dispatcher(toggleLight()) : dispatcher(toggleDark())
  }
  // console.log("picture", data?.getAuthUser?.photolink);
  return (
    <>
      {queryLoading || !userState?.id ? (
        <LoadingScreen />
      ) : (
        <Container>
          <StyledDrawer
            bodyStyle={{ padding: '0px' }}
            closable={false}
            onClose={() => setDrawerVisible(false)}
            visible={drawerVisible}
            placement="left"
            key="left"
          >
            <DrawerContainer>
              <DpContainer>
                {data?.getAuthUser?.photolink ? (
                  <img src={data?.getAuthUser?.photolink} alt="user" />
                ) : (
                  <NameAvatar>
                    <h1>{data?.getAuthUser?.firstname?.charAt(0)}</h1>{' '}
                    <h1>{data?.getAuthUser?.lastname?.charAt(0)}</h1>
                  </NameAvatar>
                )}
                <h3>
                  <span>{data?.getAuthUser?.firstname} </span>
                  <span>{data?.getAuthUser?.lastname}</span>
                </h3>
                <h2>{data?.getAuthUser?.currentCountry?.country}</h2>
              </DpContainer>
              <RouteContainer>
                {route.map((val, id) => (
                  <Nav
                    key={id}
                    onClick={() => {
                      history.push(val.route)
                      setDrawerVisible(false)
                    }}
                    active={location.pathname === val.route ? true : false}
                  >
                    <div>{val.icon}</div>
                    <p className="title-medium">{val.title}</p>
                  </Nav>
                ))}
                <div
                  style={{ cursor: 'pointer', paddingLeft: '3vw' }}
                  onClick={onChange}
                >
                  {lightmode === 'light' ? <>☀️</> : <>🌙</>}
                </div>
                {/* <Nav>
                        <div><DarkModeToggler/></div>
                    </Nav> */}
                <LogoutContainer onClick={() => handleLogOut()}>
                  <div>
                    <BiLogOutCircle />
                  </div>
                  <h1>Logout</h1>
                </LogoutContainer>
              </RouteContainer>
            </DrawerContainer>
          </StyledDrawer>
          <MobileHeader>
            <img
              src={lightmode === 'light' ? LightLogo : DarkLogo}
              alt="logo"
            />
            <div>
              <Dropdown placement={'bottomLeft'} overlay={notificationMenu}>
                <Badge
                  size="small"
                  count={listData?.getMyChatRequest?.chatRequest?.length || 0}
                >
                  <h6>
                    <BiBell size={25} />
                  </h6>
                </Badge>
              </Dropdown>
              <div>
                <h6>
                  <BiChat
                    size={25}
                    onClick={() => history.push('/home/chat')}
                  />
                </h6>
              </div>
              <div onClick={() => setDrawerVisible(true)}>
                <HiMenuAlt1 />
              </div>
            </div>
          </MobileHeader>
          <SideMenu>
            <LogoContainer src={lightmode === 'light' ? LightLogo : DarkLogo} />
            <DpContainer>
              {data?.getAuthUser?.photolink ? (
                <img src={data?.getAuthUser?.photolink} alt="user" />
              ) : (
                <NameAvatar>
                  <h1>{data?.getAuthUser?.firstname?.charAt(0)}</h1>{' '}
                  <h1>{data?.getAuthUser?.lastname?.charAt(0)}</h1>
                </NameAvatar>
              )}
              <h3>
                <span>{data?.getAuthUser?.firstname} </span>
                <span>{data?.getAuthUser?.lastname}</span>
              </h3>
              <h2>{data?.getAuthUser?.currentCountry?.country}</h2>
            </DpContainer>
            <RouteContainer>
              {route.map((val, id) => (
                <Nav
                  key={id}
                  onClick={() => history.push(val.route)}
                  active={location.pathname === val.route ? true : false}
                >
                  <div>{val.icon}</div>
                  <p className="title-medium">{val.title}</p>
                </Nav>
              ))}

              <LogoutContainer onClick={() => handleLogOut()}>
                <div>
                  <BiLogOutCircle />
                </div>
                <h1>Logout</h1>
              </LogoutContainer>
            </RouteContainer>
          </SideMenu>
          <div style={{ display: 'block', width: '100%' }}>
            <TopBar>
              <Row style={{ height: '100%' }} justify="space-between">
                <ColorCol lg={{ span: 15 }} style={{}}>
                  <h3>{props.title}</h3>
                </ColorCol>
                <TransparentCol lg={{ span: 9 }}>
                  <h5>{data?.getAuthUser?.firstname}'s Account</h5>
                  <StyledDropdown overlay={menu}>
                    <StyledIcon />
                  </StyledDropdown>
                  <div style={{ cursor: 'pointer' }}>
                    <Dropdown
                      placement={'bottomLeft'}
                      overlay={notificationMenu}
                    >
                      <Badge
                        size="small"
                        count={
                          listData?.getMyChatRequest?.chatRequest?.length || 0
                        }
                      >
                        <h6>
                          <BiBell size={25} />
                        </h6>
                      </Badge>
                    </Dropdown>
                  </div>
                  {/* <div>
                    <h6>
                      <BiLocationPlus size={25} />
                    </h6>
                  </div> */}
                  <div>
                    <h6>
                      <BiChat
                        size={25}
                        onClick={() => history.push('/home/chat')}
                      />
                    </h6>
                  </div>

                  <div style={{ cursor: 'pointer' }} onClick={onChange}>
                    {lightmode === 'light' ? <h1>☀️</h1> : <h1>🌙</h1>}
                  </div>
                </TransparentCol>
              </Row>
            </TopBar>
            <ContentContainer>
              <DashboardRoute />{' '}
            </ContentContainer>
          </div>
          <ReactionContainer id="reaction-container">
            <ReactionShadow
              onClick={() => Room.toggleReactionContainer()}
            ></ReactionShadow>
            <div className="holder">
              {roomState.reactions.map((item, index) => (
                <motion.div
                  key={`${index}`}
                  animate={{
                    rotateZ: Math.floor(Math.random() * 30),
                    x: Math.floor(Math.random() * 15),
                    y: Math.floor(Math.random() * 15),
                  }}
                  transition={{
                    repeat: Infinity,
                    repeatType: 'reverse',
                    duration: 3,
                  }}
                >
                  <div
                    key={`${index}`}
                    onClick={() => {
                      Room.toggleReactionContainer()
                      Room.sendReaction(item)
                    }}
                    className="item"
                  >
                    {item}
                  </div>
                </motion.div>
              ))}
            </div>
          </ReactionContainer>
          <MobileFooter>
            <FooterIcon
              onClick={() => history.push('/home')}
              active={location.pathname === '/home' ? true : false}
            >
              <HomeIcon />
            </FooterIcon>
            <FooterIcon
              onClick={() => history.push('/home/locate')}
              active={location.pathname === '/home/locate' ? true : false}
            >
              <LocateIcon />
            </FooterIcon>
            <FooterIcon
              onClick={() => history.push('/home/education')}
              active={location.pathname === '/home/education' ? true : false}
            >
              <IoMdSchool />
            </FooterIcon>
            <FooterIcon
              onClick={() => history.push('/home/services')}
              active={location.pathname === '/home/services' ? true : false}
            >
              <ServicesIcon />
            </FooterIcon>
            <FooterIcon
              onClick={() => history.push('/home/community')}
              active={location.pathname === '/home/community' ? true : false}
            >
              <MdVoiceChat />
            </FooterIcon>
          </MobileFooter>
        </Container>
      )}
    </>
  )
}
export default withAuthentication(AppLayout)
export const StyledDrawer = styled(Drawer)`
  border: none;
  /* background: ${(props) => props.theme.background}; */
  @media ${device.laptop} {
    display: none;
  }
`
const DrawerContainer = styled.div`
  background: ${(props) => props.theme.foreground};
  height: 100vh;
  width: 100%;
  padding: 10px 0;
`
const FooterIcon = styled.div<ActiveNav>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  font-size: 25px;
  color: ${(props) =>
    props.active ? props.theme.primaryColor : props.theme.color};
`
const MobileFooter = styled.div`
  padding: 0 10px;
  background: ${(props) => props.theme.foreground};
  z-index: 15;
  color: ${(props) => props.theme.grey};
  width: 100%;
  bottom: 0;
  height: 49px;
  position: fixed;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
  }
  @media ${device.laptop} {
    display: none;
  }
`
const MobileHeader = styled.div`
  /* background-color: red; */
  box-shadow: ${(props) => props.theme.subtleShadow};
  background: ${(props) => props.theme.foreground};
  height: 49px;
  position: fixed;
  z-index: 15;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 0;
  padding: 0 10px;
  img {
    height: 30px;
  }
  & > div {
    display: flex;
    align-items: center;
    height: 100%;
    & > div {
      display: flex;
      align-items: center;
      height: 100%;
      margin: 0 0 0 20px;
      font-size: 25px;
      color: ${(props) => props.theme.color};
    }
    h6 {
      display: flex;
      align-items: center;
      height: 100%;
      margin: 0 0 0 0;
      font-size: 15px;
      color: ${(props) => props.theme.color};
    }
  }
  @media ${device.laptop} {
    display: none;
  }
`

const ContentContainer = styled.div`
  padding: 50px 10px;
  @media ${device.laptop} {
    padding: 2vh 2vw;
  }
`

const MenuItem = styled(Menu.Item)`
  font-size: 14px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.foreground};
  :hover {
    color: ${(props) => props.theme.color};
    background: ${(props) => props.theme.grey};
  }
  @media ${device.laptop} {
    font-size: ${desktop.small};
  }
`
const StyledMenu = styled(Menu)`
  @media ${device.laptop} {
    /* width: 100px; */
  }
  background: ${(props) => props.theme.foreground};
`
const StyledIcon = styled(AiFillCaretDown)`
  color: ${(props) => props.theme.color};
  cursor: pointer;
  margin: 0 5px;
`

const StyledDropdown = styled(Dropdown)`
  font-size: 1vw;
`

const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  background: ${(props) => props.theme.background};
`
const SideMenu = styled.div`
  display: none;
  @media ${device.laptop} {
    width: 19vw;
    display: block;
    padding: 1.5vh 0 0 0;
    position: sticky;
    top: 0;
    z-index: 7;
    height: 100vh;
    left: 0;
    background: ${(props) => props.theme.foreground};
    /* box-shadow:${(props) => props.theme.subtleShadow} */
  }
`
const LogoContainer = styled.img`
  height: 2vw;
  padding-left: 3vw;
  text-align: center;
  margin: 0 auto;
`
const TopBar = styled.div`
  display: none;
  @media ${device.laptop} {
    height: 7vh;
    display: block;
    /* background:${(props) => props.theme.foreground};
  box-shadow:${(props) => props.theme.subtleShadow}; */
    position: sticky;
    top: 0;
    z-index: 4;
    width: 100%;
    padding-right: 2vw;
    h3 {
      font-size: 1.5vw;
      margin: 0;
      text-transform: capitalize;
      color: ${(props) => props.theme.color};
    }
    h6 {
      color: ${(props) => props.theme.color};
    }
  }
`
const DpContainer = styled.div`
  text-align: center;
  margin-top: 0px;
  width: 100%;
  padding-bottom: 2vh;
  border-bottom: ${(props) => `1px solid ${props.theme.subtleBlack}`};

  img {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    object-fit: cover;
  }
  & > h3 {
    margin: 0;
    margin-top: 1vh;
    color: ${(props) => props.theme.color};
    font-size: ${mobile.medium};
    span {
      text-transform: capitalize;
    }
  }
  h2 {
    color: ${(props) => props.theme.grey};
    font-style: italic;
    margin: 0;
    font-size: 14px;
  }
  @media ${device.laptop} {
    text-align: center;
    margin-top: 4.5vh;

    img {
      height: 5vw;
      width: 5vw;
    }
    & > h3 {
      font-size: ${desktop.medium};
    }
    & > h2 {
      font-size: ${desktop.small};
    }
  }
`
interface ActiveNav {
  active?: any
}
const RouteContainer = styled.div`
  margin-top: 2vh;
`
const Nav = styled.div<ActiveNav>`
  align-items: center;
  color: ${(props) =>
    props.active ? props.theme.primaryColor : props.theme.color};
  display: flex;
  margin: 10px 0;
  padding-left: 3vw;
  border-right: ${(props) =>
    props.active ? `4px solid ${props.theme.primaryColor}` : `none`};
  div {
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  p {
    margin: 0 0 0 10px;
    color: ${(props) =>
      props.active ? props.theme.primaryColor : props.theme.color};
    font-size: 16px;
  }
  @media ${device.laptop} {
    margin: 0.9vw 0;
    font-size: 'clamp(15px,0.8vw,17px)';
    font-weight: 500;
    transition: ease-in 100;
    cursor: pointer;
    div {
      display: flex;
      align-items: center;
      font-size: 'clamp(15px,0.8vw,17px)';
    }
    p {
      margin: 0 0 0 2vw;
      font-size: 'clamp(15px,0.8vw,17px)';
    }
  }
`

const LogoutContainer = styled.div`
  align-items: center;
  color: red;
  width: 100%;
  padding: 1vw 0 0 3vw;
  margin-top: 2vh;

  display: flex;
  border-top: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  div {
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  h1 {
    margin: 0 0 0 2vw;
    color: red;
    font-size: 16px;
  }
  @media ${device.laptop} {
    margin-top: 5vh;
    cursor: pointer;

    font-size: ${desktop.medium};
    h1 {
      font-size: ${desktop.normal};
    }
  }
`

const ColorCol = styled(Col)`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  display: flex;
  align-items: center;
  padding: 0 2vw;
  height: 100%;
`

const TransparentCol = styled(Col)`
  background: ${(props) => props.theme.background};
  box-shadow: none;
  z-index: 2;
  display: flex;
  align-items: center;
  padding: 0 2vw 0 1vw;
  height: 100%;
  h5 {
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    font-style: italic;
    text-transform: capitalize;
  }
  & > div {
    border-left: ${(props) => `1px solid ${props.theme.grey}`};
    height: 50%;
    display: flex;
    align-items: center;
    padding: 0 1vw;
    & > h1 {
      font-size: ${desktop.small};
      color: ${(props) => props.theme.color};
      cursor: pointer;
      & > span {
        font-size: ${desktop.small};
        margin-left: 10px;
      }
    }
    h2 {
      font-size: ${desktop.normal};
      color: ${(props) => props.theme.color};
    }
  }
`

const ReactionContainer = styled.div`
  top: 0px;
  left: 0px;
  background-color: #000000cc;
  z-index: 999999999999;
  display: none;
  visibility: hidden;
  opacity: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  place-items: center;
  .holder {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50px;
      cursor: pointer;
      height: 50px;
      margin: 15px;
      display: grid;
      place-items: center;
      font-size: 40px;
    }
  }
`

const ReactionShadow = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`
const NameAvatar = styled.div`
  height: 80px;
  width: 80px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${(props) => props.theme.subtleShadow};
  background-color: ${(props) => props.theme.tint};
  h1 {
    font-size: 20px;
    text-transform: uppercase;
    color: ${(props) => props.theme.color};
    margin: 0 4px 0 4px;
  }
  @media ${device.laptop} {
    height: 5vw;
    width: 5vw;
    h1 {
      font-size: 1.8vw;

      margin: 0 0.2vw 0 0.2vw;
    }
  }
`
